import { GetAvatarsResponseDto } from '@/entities/avatar/avatar.dto';
import { AvatarData } from '@/entities/avatar/avatar.entity';
import { AvatarMapper } from '@/entities/avatar/avatar.mapper';
import { api } from '../axiosInstance';

export const avatarService = {
  getAvatars: async (): Promise<AvatarData> => {
    const response = await api.get<GetAvatarsResponseDto>('icons/avatars');
    return AvatarMapper.toDataEntity(response.data);
  },
};
